import { render, staticRenderFns } from "./addCommondity.vue?vue&type=template&id=4234e318&scoped=true&"
import script from "./addCommondity.vue?vue&type=script&lang=js&"
export * from "./addCommondity.vue?vue&type=script&lang=js&"
import style0 from "./addCommondity.vue?vue&type=style&index=0&id=4234e318&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4234e318",
  null
  
)

export default component.exports